<template>
  <div id="tryout-group">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Paket Bimbel</li>
      <li class="active">List Paket Bimbel</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Paket Bimbel</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="createVideo()"><span class="fa fa-plus"></span> Buat Paket</button>
            </div>
            <h4 class="panel-title">Paket Bimbel</h4>
          </div>
          <div class="panel-body">
            <app-datatable :items="packageList" :has-action="true" :has-publish="true" :has-edit="true" :headers="headers"
              v-on:selected="selectedRow = $event" v-on:dblClicked="showDetail($event)" v-on:editNewTab="editPackage($event)"
              v-on:deleted="deletePackage($event)" v-on:publishing="publish($event)" v-on:unpublishing="unpublish($event)" ></app-datatable>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">DETAIL PAKET BIMBEL</h5>
          </div>
          <div class="modal-body">
            <div class="row m-5">
              <div class="col-md-4">Nama Paket</div>
              <div class="col-md-8">: <b>{{detailBimbel.name}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Deskripsi</div>
              <div class="col-md-8">: <b style="word-break:break-all !important;">{{detailBimbel.description}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Jenjang</div>
              <div class="col-md-8">: <b>{{detailBimbel.jenjang}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Kelas</div>
              <div class="col-md-8">: <b>{{detailBimbel.grade}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Kurikulum</div>
              <div class="col-md-8">: <b>{{detailBimbel.kurikulum}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Start Date</div>
              <div class="col-md-8">: <b>{{detailBimbel.start_date}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">End Date</div>
              <div class="col-md-8">: <b>{{detailBimbel.end_date}} </b></div>
            </div>
            <div class="row m-5">
              <div class="col-md-4">Mata Pelajaran</div>
            <!-- </div>
            <div class="row"> -->
              <div class="col-md-8 col-xs-12">
                <div style="width: 100%; position:relative;">
                  <div v-for="(item,index) in detailBimbel.mapel" v-bind:key="index" style="border:1px solid lightgray; padding: 5px;width: fit-content; margin-bottom: 5px; color:black;">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<style scoped>
/* .modal-body { */
  /* overflow: hidden; */
/* } */
</style>
<script>
import DataTable from '@/components/plugins/DataTable'
import bimbelService from '@/services/bimbel.js'
import AppSpinner from '@/components/plugins/Spinner'
import moment from 'moment'
import Modal from '@/components/plugins/Modal'

export default
{
  name: 'paket-bimbel',
  components: {
    'app-modal': Modal,
    'app-datatable': DataTable,
    'app-spinner': AppSpinner
  },
  data: function() {
    return {
      packageList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Nama', 'Jenjang', 'Kelas', 'Status'],
      showModal: false,
      showBab: true,
      detailBimbel: {
        name: '',
        description: '',
        jenjang: '',
        grade: '',
        kurikulum: '',
        start_date: '',
        end_date: '',
        mapel: []
      }
    }
  },
  mounted: function() {
    this.fetchData()
    this.$store.commit('video_reset')
  },
  methods: {
    fetchData: function() {
      this.packageList = []
      var context = this
      bimbelService.getListBimbel( (result) => {
        if (result.success) {
          result.data.forEach(function (packRow) {
            var row = {
              id: packRow.id,
              data: [
                packRow.name,
                packRow.jenjang,
                packRow.grade,
                packRow.status,
              ],
              status: packRow.status
            }
            // context.pagination.totalPages = group.page
            context.packageList.push(row)
          })
        }
      })
    },
    createVideo: function() {
      this.$router.push({path: '/paket-bimbel/form'})
    },
    editPackage: function() {
      var context = this
      var packageId = this.selectedRow.id
      this.$router.push({path: '/paket-bimbel/'+packageId})
    },
    showDetail: function (item) {
      // var packageId = this.selectedRow
      // console.log(this.selectedRow.id)
      var context = this
      bimbelService.getbimbelDetailById(this.selectedRow.id, function(result) {
        context.detailBimbel = {
          name: result.data.name,
          description: result.data.description,
          jenjang: result.data.grade < 7 ? 'SD' : result.data.grade < 10 ? 'SMP' : 'SMA',
          grade: result.data.grade,
          kurikulum: result.data.curriculum.name,
          start_date: moment.utc(result.data.start_date).format("YYYY-MM-DD HH:mm:ss"),
          end_date: moment.utc(result.data.end_date).format("YYYY-MM-DD HH:mm:ss"),
          mapel: result.data.block_packages
        }
      })
      $('#myModal').modal('show')
    },
    deletePackage: function(item) {
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.deleteBimbel(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data Terhapus')
            context.fetchData()
          }
        })
      }
    },
    publish: function(item){
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan publish data ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.publishBimbel(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah dipublish')
            context.fetchData()
          }
        })
      }
    },
    unpublish: function(item){
      var context = this
      var itemid = item.id
      var confirmed = window.confirm("Apakah anda yakin akan unpublish data ini?")
      if (confirmed) {
        // this.isLoading = true
        bimbelService.publishBimbel(itemid, (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah di unpublish')
            context.fetchData()
          }
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// ListPaketBimbel.vue?9f1eae20